import { COLORS } from "@coeff/utils";
import React from "react";
import styled from "styled-components";

import { Card } from "./Card";

const CardPanel = styled.div`
  display: block;
  padding: 10px;
  color: ${COLORS.black85};
  font-size: 14px;
  background-color: ${COLORS.coeblue};

  button {
    margin: 10px 0;
    padding: 2px 0;
    background: none;
    border: none;
    font: inherit;
    color: ${COLORS.coeblue4};
    font-weight: 600;
    cursor: pointer;
  }
`;

type IPWhitelistInfoCardProps = {
  noMargin?: boolean;
  dataSourceType: string;
  faqLink?: string;
  onClickFaqLink?: () => void;
};

export const IPWhiteListInfoCard: React.FC<IPWhitelistInfoCardProps> = ({
  noMargin = false,
  faqLink,
  onClickFaqLink,
}) => {
  return (
    <Card noMargin={noMargin}>
      <CardPanel>
        <div style={{ marginBottom: "10px" }}>
          You or your database admin will need to whitelist <strong>all three </strong>
          of our IP addresses:
        </div>
        <div>
          <strong>
            34.217.184.131
            <br />
            44.234.233.60
            <br />
            52.32.132.51
          </strong>
        </div>
        {faqLink && (
          <button onClick={onClickFaqLink}>
            <a href={faqLink} target="_blank" rel="noreferrer">
              Help guide
            </a>
          </button>
        )}
      </CardPanel>
    </Card>
  );
};
